/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
// CMS 스킨 '판면' (2026-09-24). Vuesax 는 SCSS 변수와 별개로 **런타임 색표**를 들고
// 버튼·칩·활성표시를 그린다. _variables.scss 만 고치면 그쪽이 안 따라와 보라가 남는다.
Vue.use(Vuesax, {
  theme: {
    colors: {
      primary: '#111111',   // 주 버튼·활성 — 먹색
      success: '#0F7B4F',
      danger:  '#EA2121',   // 중앙신문 빨강 — 삭제·송고실패 등 주의에만
      warning: '#C2410C',
      dark:    '#111111',
    },
  },
})
import VTooltip from 'v-tooltip';
Vue.use(VTooltip)
import CKEditor from '@ckeditor/ckeditor5-vue';
Vue.use(CKEditor);

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
Vue.use(VueMaterial)

import Datepicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
Vue.component('datepicker', Datepicker);

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

// axios
import axios from 'axios'
Vue.prototype.$http = axios

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'



// Feather font icon
require('./assets/css/iconfont.css')


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
